import template from './compareClubForm.template.html';

export default {
  bindings: {
    onFinished: '&',
    idTicket: '<',
    idContact: '<'
  },
  controller: class controller {
    constructor(
      $rootScope,
      $mdDialog,
      $mdMedia,
      eventService,
      uiService,
      ticketService,
      accountService,
      contactService,
      contactsService,
      homeLoanService,
      dateTimeService,
      helperService,
      compareClubService,
      COMPARE_CLUB
    ) {
      'ngInject';

      const ctrl = this;
      ctrl.$mdDialog = $mdDialog;
      ctrl.$mdMedia = $mdMedia;

      this.initialize = async () => {
        if (ctrl.idContact) {
          ctrl.contacts = await contactsService.getSpecific({
            idContacts: [ctrl.idContact],
            isActive: true
          });

          ctrl.owner = await accountService.readAccount({ id: ctrl.contacts[0].idOwner });
        } else {
          ctrl.ticket = await ticketService.readTicket({ id: ctrl.idTicket });
          ctrl.contacts = await contactsService.getSpecific({
            idContacts: ctrl.ticket.idClients,
            isActive: true
          });

          ctrl.contacts = _.sortBy(ctrl.contacts, (client) =>
            _.indexOf(ctrl.ticket.idClients, client.id)
          );

          ctrl.owner = await accountService.readAccount({ id: ctrl.ticket.idOwner });
        }

        await $mdDialog.show({
          targetEvent: null,
          locals: {
            ticket: ctrl.ticket,
            contacts: ctrl.contacts,
            owner: ctrl.owner
          },
          template,
          controllerAs: '$ctrl',
          multiple: true,
          controller(ticket, contacts) {
            const self = this;
            self.currentDateFormat = $rootScope.CurrentDateFormatPrimary();
            self.currentCurrency = $rootScope.CurrentCurrency();
            self.availableSmokingTypes = COMPARE_CLUB.QUESTIONS.YES_NO;
            self.availableGenderTypes = COMPARE_CLUB.QUESTIONS.GENDER;
            self.availableQuoteTypes = COMPARE_CLUB.QUESTIONS.QUOTE_TYPE;
            self.availableHealtFundTypes = COMPARE_CLUB.QUESTIONS.HEALTH_FUND;
            self.availableHealtCoverTypes = COMPARE_CLUB.QUESTIONS.COVER_TYPE;
            self.availableHealtLifeStage = COMPARE_CLUB.QUESTIONS.LIFE_STAGE;

            self.contact = _.head(_.filter(contacts, (c) => !c.isCompany));

            self.Model = {
              st: {
                idContact: ctrl.idContact,
                idTicket: ctrl.idTicket,
                idWorkflow: ctrl.ticket?.idWorkflow,
                idOwner: ctrl.owner.id
              },
              first_name: self.contact.person.information.firstName,
              last_name: self.contact.person.information.familyName,
              smoker: 0,
              state: self.contact.person.contact.address.state,
              gender: self.contact.person.information.gender.name,
              email: self.contact.person.contact.email,
              age: self.contact.person.information.dateOfBirth
                ? moment().diff(
                    moment.utc(self.contact.person.information.dateOfBirth, 'X'),
                    'years'
                  )
                : '',
              quote_type: '',
              life_cover: 0,
              phone: self.contact.person.contact.primary.replace(/\s/g, ''),
              occupation: 307,
              health_fund: '',
              cover_type: '',
              life_stage: ''
            };

            self.sending = false;
            self.response = null;

            self.cancel = () => {
              $mdDialog.hide(false);
            };

            self.isAuNumber = () => {
              const phone = self.contact.person.contact.primary;

              if (phone[0] !== '0') {
                return false;
              }

              return phone.length === 10;
            };

            self.confirm = async () => {
              self.sending = true;
              uiService.toast({
                text: {
                  p1: 'Sending',
                  p2: 'Please wait...'
                }
              });

              self.response = await compareClubService.send(self.Model);

              if (!self.response.status) {
                eventService.lodgementResponseErrors({
                  errors: self.response.errors,
                  errorMessage: self.response.message || self.response.errorMessage,
                  provider: 'Compare Club'
                });
              }

              uiService.toast({
                text: {
                  p1: 'Response',
                  p2: 'was',
                  p3: self.response?.status ? 'Successful' : 'Erroneous'
                },
                warn: !self.response?.status,
                success: self.response?.status
              });

              ctrl.onFinished();
            };
          }
        });

        ctrl.onFinished();
      };

      this.$onInit = () => {
        ctrl.initialize();
      };
    }
  }
};
